import { isMobile } from '../../utils';

let premiumContentMap = [
	{
		question: '<p>Match this dish to its country of origin</p>',
		nameCountry: ['India'],
		nameDish: 'Palak Paneer',
		mapCenter: { lng: 100.86302582227307, lat: 18.256160521830182 },
		mapCenterMobile: { lng: 91.78271103685563, lat: 24.416906233564966 },
		zoomMobile: 2.7198156790192494,
		imgPositionMobile: 'img-is-cover',
		img: 'img/culinary/india.jpg',
		hint: '<b>HINT:</b> The cuisine in this country is known for its complex flavors and use of aromatic herbs and spices.',
		text: '<p>A popular vegetarian dish in Indian cuisine, Palak Paneer consists of cubes of paneer (a type of Indian cottage cheese) in a creamy curry sauce made with spinach blended with aromatic spices. Rich and comforting, it is served with jeera pulao (cumin rice) onboard Singapore Airlines.</p>',
		textOpen:
			"<p>Cabin pressure and humidity levels can alter the way flavors are perceived. That's why Singapore Airlines’ chefs’ creations undergo rigorous testing in a simulated pressurized cabin, ensuring they are perfectly fine-tuned for your in-flight dining experience.</p><p>Inspired by global cultures and experiences, culinary offerings at Singapore Airlines are overseen by an International Culinary Panel—comprising five world-renowned chefs from Australia, China, France, India, and Japan—constantly innovating the in-flight menu to delight your palate.</p>",
	},
	{
		question: '<p>Match this dish to its country of origin</p>',
		nameCountry: ['Japan'],
		nameDish: 'Teriyaki Salmon',
		mapCenter: { lng: 131.66666990157364, lat: 26.10516454883086 },
		mapCenterMobile: { lng: 118.44433532266476, lat: 29.272391697394074 },
		zoomMobile: 2.4210793366761507,
		imgPositionMobile: 'img-is-cover',
		img: 'img/culinary/japan.jpg',
		hint: '<b>HINT:</b> The cuisine in this country is known for its fresh, high-quality ingredients, refined presentation, and balance of flavors.',
		text: '<p>Fresh salmon fillets are glazed with a sweet and savory teriyaki sauce made from sugar, mirin, and soy sauce. The salmon is then grilled, giving it a delightful caramelization.</p>',
		textOpen:
			"<p>Cabin pressure and humidity levels can alter the way flavors are perceived. That's why Singapore Airlines’ chefs’ creations undergo rigorous testing in a simulated pressurized cabin, ensuring they are perfectly fine-tuned for your in-flight dining experience.</p><p>Inspired by global cultures and experiences, culinary offerings at Singapore Airlines are overseen by an International Culinary Panel—comprising five world-renowned chefs from Australia, China, France, India, and Japan—constantly innovating the in-flight menu to delight your palate.</p>",
	},
	{
		question: '<p>Match this dish to its country of origin</p>',
		nameCountry: ['China', 'Hong Kong', 'Macao'],
		nameDish: 'Braised Egg Noodle',
		// mapCenter: { lng: 123.58612728048516, lat: 26.860785917197656 },
		mapCenter: { lng: 130.42715597795188, lat: 34.50127251764881 },
		imgPositionMobile: 'img-is-cover',
		img: 'img/culinary/china-2.jpg',
		hint: '<b>HINT:</b> The cuisine in this country is incredibly diverse, varying from region to region, with rice and noodles as its staple foods.',
		text: '<p>Known for its savory taste and comforting texture, this dish features egg noodles braised in a flavorful broth, often accompanied by vegetables and a protein such as chicken, pork, or shrimp.</p>',
		textOpen:
			"<p>Cabin pressure and humidity levels can alter the way flavors are perceived. That's why Singapore Airlines’ chefs’ creations undergo rigorous testing in a simulated pressurized cabin, ensuring they are perfectly fine-tuned for your in-flight dining experience.</p><p>Inspired by global cultures and experiences, culinary offerings at Singapore Airlines are overseen by an International Culinary Panel—comprising five world-renowned chefs from Australia, China, France, India, and Japan—constantly innovating the in-flight menu to delight your palate.</p>",
	},
	{
		question: '<p>Match this dish to its country of origin</p>',
		nameCountry: ['Korea'],
		visibleCountryName: 'SOUTH KOREA',
		nameDish: 'Beef Bulgogi',
		mapCenter: { lng: 128.67978747844143, lat: 31.497045921706096 },
		mapCenterMobile: { lng: 120.19259624675877, lat: 30.453437776985957 },
		zoomMobile: 2.815307929818124,
		imgPositionMobile: 'img-is-cover',
		img: 'img/culinary/korea-2.jpg',
		hint: '<b>HINT:</b> The cuisine in this country is known for its bold, robust flavors and a wide variety of side dishes.',
		text: '<p>Thinly sliced beef is marinated in a sweet and savory sauce made from soy sauce, sesame oil, garlic, and sugar, then grilled or stir-fried to tender perfection, and served with rice and kimchi.</p>',
		textOpen:
			"<p>Cabin pressure and humidity levels can alter the way flavors are perceived. That's why Singapore Airlines’ chefs’ creations undergo rigorous testing in a simulated pressurized cabin, ensuring they are perfectly fine-tuned for your in-flight dining experience.</p><p>Inspired by global cultures and experiences, culinary offerings at Singapore Airlines are overseen by an International Culinary Panel—comprising five world-renowned chefs from Australia, China, France, India, and Japan—constantly innovating the in-flight menu to delight your palate.</p>",
	},
	// {
	// 	question: '<p>Match this dish to its country of origin</p>',
	// 	nameCountry: ['United Kingdom'],
	// 	nameDish: 'Herb Crusted Fish',
	// 	mapCenter: { lng: 22.857725363735735, lat: 49.178060305285 },
	// 	imgPositionMobile: 'img-is-contain',
	// 	img: 'img/culinary/uk.jpg',
	// 	hint: '<b>HINT:</b> The cuisine in this country is known for its comfort food and traditional meals including roast dinners and an afternoon tea culture.',
	// 	text: '<p>A variation of the classic fish and chips dish, fish fillets are coated with a mixture of herbs and breadcrumbs, and baked or fried until the crust is crisp, with the herbs providing a fresh, aromatic flavor that complements the delicate fish.</p>',
	// 	textOpen:
	// 		"<p>Cabin pressure and humidity levels can alter the way flavors are perceived. That's why Singapore Airlines’ chefs’ creations undergo rigorous testing in a simulated pressurized cabin, ensuring they are perfectly fine-tuned for your in-flight dining experience.</p><p>Inspired by global cultures and experiences, culinary offerings at Singapore Airlines are overseen by an International Culinary Panel—comprising five world-renowned chefs from Australia, China, France, India, and Japan—constantly innovating the in-flight menu to delight your palate.</p>",
	// },
	// {
	// 	titleFirstBannerCorrect: 'You’re a Seasoned Culinary Traveler!',
	// 	textFirstBannerCorrect: '',
	// 	titleFirstBannerWrong: 'You’re a Budding Food Explorer!',
	// 	textFirstBannerWrong: '',
	// },
];

premiumContentMap = premiumContentMap.map((item) => {
	return {
		...item,
		mapCenter: isMobile && item.mapCenterMobile ? item.mapCenterMobile : item.mapCenter,
	};
});

export { premiumContentMap };
